import { useTranslation } from 'react-i18next';

/**
 * Honest stand-in for a route that exists in the navigation but whose screen is built
 * later in this phase. Better than a 404 behind a visible menu item.
 */
export default function PlaceholderPage({
  titleKey,
}: {
  titleKey: 'nav.users' | 'nav.teams' | 'nav.audit' | 'nav.settings' | 'nav.notifications';
}) {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-2">
      <h1 className="text-xl font-bold text-slate-900">{t(titleKey)}</h1>
      <p className="text-sm text-slate-500">{t('pages.comingSoon')}</p>
    </section>
  );
}
